module.exports = __webpack_public_path__ + "img/bob-the-waschmeister.4dc971fe.png";